import React from "react";
import "./pages.css";
import {
  Box,
  Grid,
  LinearProgress,
  LinearProgressProps,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import imag from "../assets/DSC_1259.jpg";
import { isMobile } from "react-device-detect";

const myInfo = [
  { sub: "birthday", data: new Date(1999, 7, 10).toDateString() },
  { sub: "Website", data: "https://www.test.com" },
  { sub: "Phone", data: "+212657821933" },
  { sub: "City", data: "Kenitra" },
  { sub: "Email", data: "azlarab.oujdad.izo@gmail.com" },
];

const mySkills = [
  {
    sub: "React Js :",
    description:
      "I've been working with React since 2022 with both javascript and typescript, and since then I've gotten too familiar with hooks and stats, as well as some interesting dependencies such as react query.",
  },
  {
    sub: "TypeScript :",
    description:
      "What I think is wonderful about typescript is that it helps teams work together because every function or component is predefined with the typing, so the chance for bugs is lower and the data flow will be more fluid and secure.",
  },
  {
    sub: "node Js :",
    description:
      "Well nodejs express will be the best technology for every JS/TS developer to manage the backend for every kind of projects. Worked with it since 2022.",
  },
  {
    sub: "SQL :",
    description:
      "Since I've been working on the backend from time to time. I had to use SQL by sending direct queries to the database or by using 'sequelize' with Node Js. I've got good experience in handling data with SQL.",
  },
  {
    sub: "MongoDb :",
    description:
      "NoSql database can be so fast compared to SQL DB in some cases and I had to work with it multiple times spacially while we need to handle a large amount of data.",
  },
  {
    sub: "CSS :",
    description:
      "Well for sure the frontend needs to be pretty that's why I've been using CSS all my career in addition to SASS or LESS",
  },
];

const myInfoSlicePoint =
  myInfo.length % 2 === 0 ? myInfo.length / 2 : myInfo.length / 2 + 1;

const skillsStyle = {
  color: "info.main",
  "& .MuiListItemText-primary": {
    textDecoration: "underline",
    textDecorationColor: "primary.main",
    textDecorationThickness: "2px",
  },
};

const myInfoStyle = {
  color: "info.main",
  "& .MuiListItemText-secondary": {
    color: "info.main",
  },
};
function About() {
  return (
    <Box sx={{ flexGrow: 1, margin: "3%" }}>
      <Grid container spacing={2} height="100%">
        <Grid item xs={12}>
          <Box
            sx={{
              borderWidth: "0px 0px 5px 0px",
              borderStyle: "solid",
              borderColor: "primary.main",
              width: "fit-content",
            }}
          >
            <Typography
              variant="h2"
              color="primary.main"
              sx={{ textAlign: "start", marginTop: "5%" }}
            >
              About
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Typography color="info.main">
            The first time my father got me a computer, I never thought that I
            could be a developer since I didn't know what it meant. Later, when
            I started to understand how programming and the software industry
            work. I started learning to code starting with 'C language, and it
            took me time to learn it. But after finishing high school, I
            dedicated my time to learning more about it, and I've taken my
            diploma in software development for 2021. Since then, I've been
            working as a professional software developer. 
          </Typography>
        </Grid>
        {isMobile ? (
          <></>
        ) : (
          <Grid item xs={3}>
            <img style={{ width: "100%", height: "auto" }} src={imag} />
          </Grid>
        )}

        <Grid item xs={isMobile ? 12 : 9}>
          <Grid container spacing={2} height="100%">
            <Grid item xs={12}>
              <Typography
                sx={{
                  borderWidth: "0px 0px 5px 0px",
                  borderStyle: "solid",
                  borderColor: "primary.main",
                  width: "fit-content",
                }}
                color="primary.main"
                variant="h6"
              >
                Software Developer
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography color="info.main">
                My professional experience started with smart automation
                technology, where we were working on web apps using Angular and
                Node JS. After a while, I got another job in Terabyte software
                engineering, where I learned more about frontend development. My
                job was as a front-end developer with React. I worked on
                different projects, such as insightsRadar and others, where I
                added new features and fixed multiple bugs.
              </Typography>
            </Grid>
            {isMobile ? (
              <Grid item xs={12}>
                <List>
                  {myInfo.map((item) => (
                    <ListItem>
                      <ListItemIcon>
                        <ArrowForwardIosIcon color="info" />
                      </ListItemIcon>
                      <ListItemText
                        sx={myInfoStyle}
                        primary={item.sub}
                        secondary={item.data.toString()}
                      />
                    </ListItem>
                  ))}
                </List>
              </Grid>
            ) : (
              <>
                <Grid
                  item
                  xs={6}
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <List>
                    {myInfo.slice(0, myInfoSlicePoint).map((item) => (
                      <ListItem>
                        <ListItemIcon>
                          <ArrowForwardIosIcon color="info" />
                        </ListItemIcon>
                        <ListItemText
                          sx={myInfoStyle}
                          primary={item.sub}
                          secondary={item.data.toString()}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <List>
                    {myInfo
                      .slice(myInfoSlicePoint, myInfo.length)
                      .map((item) => (
                        <ListItem>
                          <ListItemIcon>
                            <ArrowForwardIosIcon color="info" />
                          </ListItemIcon>
                          <ListItemText
                            sx={myInfoStyle}
                            primary={item.sub}
                            secondary={item.data.toString()}
                          />
                        </ListItem>
                      ))}
                  </List>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2} height="100%">
            <Grid item xs={12}>
              <Typography
                sx={{
                  borderWidth: "0px 0px 5px 0px",
                  borderStyle: "solid",
                  borderColor: "primary.main",
                  width: "fit-content",
                }}
                color="primary.main"
                variant="h6"
              >
                Skills
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography color="info.main">
                You can find most of my technical skills here, which I have been
                using lately in my job to produce the best version of the
                product.
              </Typography>
            </Grid>
            {isMobile ? (
              <Grid item xs={12}>
                <List>
                  {mySkills.map((item) => (
                    <ListItem>
                      <ListItemText
                        sx={skillsStyle}
                        primary={item.sub}
                        secondary={
                          <Box sx={{ width: "100%" }}>
                            <Typography color="info.main">
                              {item.description}
                            </Typography>
                          </Box>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </Grid>
            ) : (
              <>
                <Grid item xs={6}>
                  <List>
                    {mySkills.slice(0, mySkills.length / 2).map((item) => (
                      <ListItem>
                        <ListItemText
                          sx={skillsStyle}
                          primary={item.sub}
                          secondary={
                            <Box sx={{ width: "100%" }}>
                              <Typography color="info.main">
                                {item.description}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </Grid>
                <Grid item xs={6}>
                  <List>
                    {mySkills
                      .slice(mySkills.length / 2, mySkills.length)
                      .map((item) => (
                        <ListItem>
                          <ListItemText
                            sx={skillsStyle}
                            primary={item.sub}
                            secondary={
                              <Box sx={{ width: "100%" }}>
                                <Typography color="info.main">
                                  {item.description}
                                </Typography>
                              </Box>
                            }
                          />
                        </ListItem>
                      ))}
                  </List>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default About;
